import React from "react";

import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled } from "@mui/material/styles";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";

import { Card, Box, Tooltip, Stack } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Edit from "../../../icons/edit.svg";
import Trash from "../../../icons/trash1.svg";
import Replace from "../../../icons/replace.png";
import Restore from "../../../icons/Restore.svg";
import { useState, useEffect } from "react";
import useFetch from "../../../utils/useFetch";
import BaseURL from "../../../utils/base-uri.json";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import axios from "../../../utils/fvAxios";
import GetfVDateFormate from "../../../utils/Genaricfunctions";
import SupportingDocumentEdit from "./SupportingDocumentEdit";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CreateIcon from '@mui/icons-material/Create';
import fileDownload from "js-file-download";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Logo from "../../../Media/Upload.jpeg";
import { useCallback, useMemo } from "react";
import { useDropzone } from "react-dropzone";
import { useTranslation } from "react-i18next";
import EmptyComponent from "../../../utils/EmptyComponent";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { getOrgType } from "../../../utils/Token";
import dayjs from 'dayjs';
import CheckCircleBlue from "../../../icons/CheckCircleBlue.svg";
import CancelCircleBlue from "../../../icons/CancelCircleBlue.svg";

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&:before": {
    display: "none",
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

export default function SupportingDocuments({
  Secid,
  SubId,
  SectionType,
  SubSectionTypeCondition,
  PQCLIENTID,
  ClientTemplate,
  VIEWMODE,
  PqStatusID
}) {

  const toastNotify = (message, isSuccess = true) => {
    if (isSuccess) {
      toast.success(message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  const [expanded, setExpanded] = React.useState(false);
  const [expanded1, setExpanded1] = React.useState(false);
  const [showPrompt, setShowPrompt] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const [accordiansExpanded, setAccordionsExpanded] = useState([0]);
  const [accordiansExpanded1, setAccordionsExpanded1] = useState([0]);
  const handleAccordion = (panel) => (event, isExpanded) => {
    if (accordiansExpanded.includes(panel)) {
      const arr = accordiansExpanded.filter((idx) => idx !== panel);
      setAccordionsExpanded(arr);
    } else setAccordionsExpanded((prev) => prev.concat(panel));
  };
  const handleAccordion1 = (panel) => (event, isExpanded) => {
    if (accordiansExpanded1.includes(panel)) {
      const arr = accordiansExpanded1.filter((idx) => idx !== panel);
      setAccordionsExpanded1(arr);
    } else setAccordionsExpanded1((prev) => prev.concat(panel));
  };

  const DocumentsOpen = () => {
    setExpanded(expanded);
  };
  const DeletedDocuments = () => {
    setExpanded1(expanded1);
  };
  const getGroupData = (pqLocations) => {
    //pqLocations = pqLocations.sort((a, b) => a.documentTypeName.localeCompare(b.documentTypeName));
    const sortedAndGroupedData = pqLocations
      .sort((a, b) => a.documentTypeName.localeCompare(b.documentTypeName))
      .reduce((acc, product) => {
        const { documentTypeId } = product;
        if (!acc.ids.includes(documentTypeId)) {
          acc.ids.push(documentTypeId);
          acc.groups[documentTypeId] = [];
        }
        acc.groups[documentTypeId].push(product);
        return acc;
      }, { ids: [], groups: {} });

    return sortedAndGroupedData.ids.map((id) => ([id, sortedAndGroupedData.groups[id].sort((a, b) => a.documentTypeName.localeCompare(b.documentTypeName)),
    ]))

    return Object.entries(
      pqLocations?.reduce((group, product) => {
        const { documentTypeId } = product;
        group[documentTypeId] = group[documentTypeId] ?? [];
        group[documentTypeId].push(product);
        return group;
      }, {})
    );
  };
  const param = new URLSearchParams(window.location.search);
  const PQID = param.get("pqid");
  const [response, setResponse] = useState([]);
  const [refreshDocs, setRefreshDocs] = React.useState(true);

  const [clientList, setClientsList] = useState([]);
  const [docclientId, setDocClientId] = useState("");

  useEffect(() => {
    setIsLoading(true);
    axios
      .get(
        BaseURL.baseUrl +
        "Prequalification/SectionOrSubSectionDetails?pqId=" +
        PQID +
        "&sectionId=" +
        Secid +
        "&subSectionTypeCondition=" +
        SubSectionTypeCondition +
        "&sectionType=" +
        SectionType +
        "&subSectionId=" +
        SubId
      )
      .then((resp) => {
        setResponse(Object.entries(resp?.data?.data));
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
      }).finally(() => {
        setIsLoading(false);
      });
    setExpanded(true);
  }, [refreshDocs]);

  const [DeleteDocId, setDeleteDocId] = React.useState("");
  const [DeletePop, setDeletePop] = React.useState(false);
  const [DeleteDis, setDeleteDis] = React.useState(false);
  const RemovieFile = async (e) => {
    setDeleteDis(true);
    const res = await axios.post(
      "Prequalification/RemoveDocument?documentId=" + DeleteDocId
    );
    toast.success(res?.data?.data, {
      position: "top-right",
      autoClose: 4000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
    setRefreshDocs(!refreshDocs);
    setDeletePop(false);
    setDeleteDis(false);
  };

  const HandleDownloadClose = () => {
    setDeletePop(false);
  };
  const HandleDownloadopen = (e) => {
    setDeleteDocId(e?.documentId);
    setDeletePop(true);
  };

  const [values, setValues] = useState(""); // Initialize with an empty string

  const ChangeDocName = (e) => {
    if (e.endsWith(".pdf")) {
      setValues(e.slice(0, -4));
    } else {
      setValues(e);
    }
  };

  const handleClick = (rec) => {
    setValues(rec.documentName); // Set the input field to the current document name
    response.forEach((element) => {
      if (element[1].find((r) => r.documentId == rec.documentId)) {
        element[1].find((r) => r.documentId == rec.documentId).toggle =
          !element[1].find((r) => r.documentId == rec.documentId).toggle;
      }
    });
    setResponse([...response]);
  };

  const EditFile = async (e) => {
    let newDocName = values;
    if (!newDocName.endsWith(".pdf")) {
      newDocName += ".pdf";
    }

    const data = {
      docID: e.documentId,
      docNameNew: newDocName,
    };

    const res = await axios.post("Prequalification/ChangeDocumentName", data);
    toastNotify(res?.data?.data, true);

    response.forEach((element) => {
      if (element[1].find((r) => r.documentId == e.documentId)) {
        element[1].find((r) => r.documentId == e.documentId).toggle =
          !element[1].find((r) => r.documentId == e.documentId).toggle;
      }
    });
    setResponse([...response]);
    setValues(""); // Clear the state after saving
    setRefreshDocs(!refreshDocs);
  };


  const [trig, setTrig] = useState(false);
  const [triger, setTriger] = useState(false);
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [SupportDocTypes, setSupportDocTypes] = useState([]);
  const [DocTypeID, setDocTypeID] = useState("");

  useEffect(() => {
    axios
      .get(
        "Prequalification/GetSupportDocTypes?pqId=" +
        PQID +
        "&sectionId=" +
        Secid +
        "&clientId=" +
        docclientId
      )
      .then((res) => {
        if (res?.data?.status == true) {
          setSupportDocTypes(res?.data?.data);
        } else {
          alert(res?.data?.responseMessage);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [triger]);

  useEffect(() => {
    if (open) {
      if (SupportDocTypes?.length == 0 && (DocTypeID == undefined || DocTypeID == null || DocTypeID == "" || DocTypeID == 0)) {
        setShowPrompt(true)
      }
      if (showPrompt && SupportDocTypes?.length > 0)
        setShowPrompt(false)

    }

  }, [DocTypeID, SupportDocTypes]);

  const PqNonStatusList = [3, 15, 27, 7];
  const [id, setId] = useState("");
  const [DocTypes, setDocTypes] = useState("");
  const [documentId, setDocumentId] = useState("");

  const [newDate, setNewDate] = useState(dayjs());
  const [files, setFiles] = useState([]);
  const [fileReset, setFileReset] = useState(true);


  const ChangeDate = (e) => {

    const adjustedDate = dayjs(e).startOf('day');
    //setNewDate(adjustedDate);
    setNewDate(adjustedDate?.format('MM/DD/YYYY'));
  };

  const [IsMuliClient, setIsMuliClient] = useState("");

  const handleClickOpen = (r, num) => {
    var d = new Date();
    var year = d.getFullYear();
    var month = d.getMonth();
    var day = d.getDate();
    //const NEWDATE = new Date(year, month, day + 2).toISOString()?.split('T', 1)[0];

    if (num == 1 || num == 4 || num == 5) {
      setNewDate(null);
    } else {
      if (r.expires != null) {
        const dates = r.expires?.split("T", 1)[0];
        //setNewDate(dates);
        const dateObject = new Date(dates);
        const day = String(dateObject.getDate()).padStart(2, '0'); // Ensure 2 digits
        const month = String(dateObject.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const year = dateObject.getFullYear();

        // Format the date as "dd/mm/yyyy"

        const formattedDate = `${month}/${day}/${year}`
        setNewDate(formattedDate);
      }
      else {
        setNewDate(null);
      }
    }

    setId(num);
    setOpen(true);
    setDocumentId(r?.documentId);
    setDocTypeID(r?.documentTypeId);
    setDocClientId(r?.clientId);

    setDocTypes(r?.expires != null ? true : false);

    setTrig(!trig);
    setTriger(!triger);
    setFiles([]); //File  Reset
  };
  const handleClose = () => {
    setOpen(false);
    setFileReset(fileReset);
  };

  useEffect(() => {
    axios
      .get(BaseURL.baseUrl + "Prequalification/GetPqClients?pqId=" + PQID)
      .then((resp) => {
        if (id == 4) {
          setClientsList(resp?.data?.data.filter((r) => r?.key != PQCLIENTID));
          setDocClientId(
            resp?.data?.data.filter((r) => r?.key != PQCLIENTID)[0]?.key
          );
          setTriger(!triger);
        } else if (id == 5) {
          setClientsList(resp?.data?.data.filter((r) => r?.key == PQCLIENTID));
          setDocClientId(
            resp?.data?.data.filter((r) => r?.key == PQCLIENTID)[0]?.key
          );
          setTriger(!triger);
        } else {
          setClientsList(
            resp?.data?.data?.filter((r) => r?.key == docclientId)
          );
        }
      })
      .catch((err) => {
        console.log(err);
      });

    // if (getOrgType() == "Vendor") {
    axios
      .get("Prequalification/IsMultiClientTemplate?pqId=" + PQID)
      .then((resp) => {
        setIsMuliClient(resp?.data?.data);
      })
    // }

  }, [trig]);

  const handleChanged = (e) => {
    setDocTypeID(e);
    const SupDocTypes = SupportDocTypes?.find((r) => r.docTypeID == e);
    setDocTypes(SupDocTypes?.isExpires);
  };
  const DoccClienthange = (e) => {
    setDocClientId(e);
    if (id == 4 || 5) setTriger(!triger);
  };

  const handleDownload = (e) => {
    axios
      .get(
        BaseURL.baseUrl +
        "Documents/DownloadDocument?idAsFileName=" +
        e?.documentId,
        {
          responseType: "blob",
        }
      ).then((res) => {
        if (res?.data?.type == "application/json") {
          toastNotify("File not found", false);
        } else {

          const file = new Blob([res.data], { type: "application/pdf" });
          //Build a URL from the file
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;

          // const blob = new Blob([res.data], { type: res.headers['content-type'] });
          // const blobUrl = URL.createObjectURL(blob);
          // // Open the Blob URL in a new tab
          // window.open(blobUrl, '_blank');
          // // Revoke the Blob URL after opening to free up resources
          // URL.revokeObjectURL(blobUrl);
        }
      })

    //   fileDownload(res?.data, e?.documentName);
    // });
  };

  const ITEM_HEIGHT = 50;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 2 + ITEM_PADDING_TOP,
        width: 200,
      },
    },
  };

  const { t } = useTranslation();

  const activeStyle = {
    borderColor: "#2196f3",
  };

  const acceptStyle = {
    borderColor: "#00e676",
  };

  const rejectStyle = {
    borderColor: "#ff1744",
  };
  const onDrop = useCallback((acceptedFiles) => {
    setFiles(
      acceptedFiles?.map((file) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        })
      )
    );
  }, []);

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    onDrop,
    accept: "pdf",
    maxFiles: 1,
    // maxSize: 10615705
  });

  const mmmt = useMemo(
    () => ({
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isDragActive, isDragReject, isDragAccept]
  );

  const thumbs = files?.map((file) => <div key={file?.name}>{file?.name}</div>);
  // clean up
  useEffect(
    () => () => {
      files?.forEach((file) => URL.revokeObjectURL(file?.name));
    },
    [fileReset]
  );

  // const [file, setFile] = useState({});
  // const [fileName, setFileName] = useState("");
  // const saveFile = (e) => {
  //     setFile(e.target.files[0]);
  //     setFileName(e.target.files[0].name);
  // };

  const [Dis, setDis] = useState(false);

  const uploadFile = async () => {
    setDis(true);
    const ExpiryDate = DocTypes ? newDate : null;
    const CLIENT = docclientId == "" ? PQCLIENTID : docclientId
    if (id == 1 || id == 4 || id == 5) {
      if ((files[0] && files[0] != null && DocTypeID != null) && (DocTypes == true ? newDate != null : newDate == null)) {

        if (files[0]?.size < 10615705) {
          const data = {
            "documentTypeId": DocTypeID + "",
            "expiryDate": ExpiryDate,
            "subSectionId": SubId,
            "documentId": null,
            "mode": 0,
            "prequalificationId": PQID,
            "clientId": CLIENT,
            "sectionId": Secid,
            "newFile": files[0]
          }

          axios.post("Prequalification/SavesupportDocument", data, {
            headers: {
              "Content-Type": "multipart/form-data",
            }
          }).then((res) => {
            if (res?.data?.data == "Success") {
              toastNotify(res?.data?.data, true);
              setRefreshDocs(!refreshDocs);
              setOpen(false);
            } else {
              toastNotify(res?.data?.data, false);
              setOpen(true);
            }
          }).finally(() => {
            setTimeout(() => {
              setDis(false);
            }, 5000)
          })
        }
        else {
          toastNotify("File size must be below 10 mb", false);
          setOpen(true);
          setTimeout(() => {
            setDis(false);
          }, 5000)
        }
      } else {
        if (DocTypeID == null || (DocTypes == true && newDate == null)) {
          toastNotify("Please fill all required fields", false)
          setOpen(true);
          setTimeout(() => {
            setDis(false);
          }, 5000)
          return;
        }
        if (!files[0]) {
          toastNotify("Please Upload a file", false);
          setOpen(true);
          setTimeout(() => {
            setDis(false);
          }, 5000)
          return;
        }

      }

    }
    else if (id == 2) {
      if (DocTypes == true && newDate == null) {
        toastNotify("Please enter Expiration Date for the Document", false)
        setDis(false);
      }
      else {
        const data = {
          "documentTypeId": DocTypeID + "",
          "expiryDate": ExpiryDate,
          "subSectionId": SubId,
          "documentId": documentId, //send id
          "mode": 1,
          "prequalificationId": PQID,
          "clientId": docclientId,
          "sectionId": Secid,
          "newFile": files[0]
        }

        axios.post("Prequalification/SavesupportDocument", data, {
          headers: {
            "Content-Type": "multipart/form-data",
          }
        }).then((res) => {
          if (res?.data?.data == "Success") {
            toastNotify(res?.data?.data, true);
            setRefreshDocs(!refreshDocs);
            setOpen(false);
          } else {
            toastNotify(res?.data?.data, false);
            setOpen(true);
          }
        }).finally(() => {
          setTimeout(() => {
            setDis(false);
          }, 5000)
        })
      }
    }
    else {
      if (DocTypes == true && newDate == null) {
        toastNotify("Please enter Expiration Date for the Document", false)
        setDis(false);
      }
      else {
        if (files[0] != null && files[0]?.size < 10615705) {
          const data = {
            "documentTypeId": DocTypeID + "",
            "expiryDate": ExpiryDate,
            "subSectionId": SubId,
            "documentId": documentId, //send id
            "mode": null,
            "prequalificationId": PQID,
            "clientId": docclientId,
            "sectionId": Secid,
            "newFile": files[0]
          }
          axios.post("Prequalification/SavesupportDocument", data, {
            headers: {
              "Content-Type": "multipart/form-data",
            }
          }).then((res) => {
            if (res?.data?.data == "Success") {
              toastNotify(res?.data?.data, true);
              setRefreshDocs(!refreshDocs);
              setOpen(false);
            } else {
              toastNotify(res?.data?.data, false);
              setOpen(true);
            }
          }).finally(() => {
            setTimeout(() => {
              setDis(false);
            }, 5000)
          })

        }

        else {
          if (!files[0]) {
            toastNotify("Please Upload a file", false)
          } else {
            toastNotify("File size must be below 10 mb", false)
          }
          setOpen(true);
          setTimeout(() => {
            setDis(false);
          }, 5000)
        }
      }
    }

    // setOpen(false);
    // setRefreshDocs(!refreshDocs);
  };

  const [history, setHistory] = useState([]);
  const [historyOpen, setHistoryOpen] = React.useState(false);
  const [DocName, setDocName] = React.useState("");
  const [message, setMessage] = React.useState("");

  const DocHistoryhandle = (e) => {
    setHistoryOpen(true);
    setDocName(e.documentName);
    axios
      .get("Prequalification/GetDocumentLog?documentId=" + e.documentId)
      .then((res) => {
        if (res?.data?.status === true) {
          setHistory(res?.data?.data);
        } else {
          toastNotify(res?.data?.responseMessage, false)
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const HistoryClose = () => {
    setHistoryOpen(false);
  };

  const RejectORAprove = (r) => {
    if (r?.documentStatus == "Rejected" || r?.documentStatus == null) {
      axios
        .post(
          "Prequalification/ChangeDocStatus?DocId=" +
          r?.documentId +
          "&newStatus=" +
          "Approved"
        )
        .then((res) => {
          if (res?.data?.data == "Success") {
            toastNotify(res?.data?.data, true);
            setRefreshDocs(!refreshDocs);
          } else {
            toastNotify(res?.data?.data, false);
          }
        });
    } else {
      axios
        .post(
          "Prequalification/ChangeDocStatus?DocId=" +
          r?.documentId +
          "&newStatus=" +
          "Rejected"
        )
        .then((res) => {
          if (res?.data?.data == "Success") {
            toastNotify(res?.data?.data, true);
            setRefreshDocs(!refreshDocs);
          } else {
            toastNotify(res?.data?.data, false);
          }
        });
    }
    //setRefreshDocs(!refreshDocs);
  };

  const PresentDate = new Date();
  const [Lock, setLock] = useState(false);

  const ALockUnlock = () => {
    setLock(!Lock);
  }
  const handleDateKeyDown = (e) => {
    e.preventDefault();// Prevent manual date input
  };
  const StyledTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))`
    & .MuiTooltip-tooltip {
      background:  rgba(97, 97, 97, 0.92)!important;
      color:#fff !important
    }
       & .MuiTooltip-arrow: {
      color: rgba(97, 97, 97, 0.92)!important;
    }
  `;
  return (
    <div style={{ backgroundColor: "#fff" }}>
      <ToastContainer />
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {/* <div>
        <p className="mx-3">
          If you need assistance with the requirements below, please contact
          your company's computer technical support.{" "}
        </p>
        <p className="mx-3"> - Files must be in PDF format.</p>
        <p className="mx-3">
          {" "}
          -The maximum size for each file is 10 megabytes (MB)
        </p>
        <p className="mx-3">
          {" "}
          - Scan multiple pages into one (1) PDF document where requested{" "}
        </p>
        <p className="mx-3">
          {" "}
          Click 'Add New' to view documents (see Introduction page for required
          and optional documents).
        </p>
      </div> */}

      <Accordion
        onChange={DocumentsOpen}
        sx={{ backgroundColor: "#F9FAFB" }}
        defaultExpanded
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography sx={{ width: "33%", flexShrink: 0 }}>
            Supporting Documents
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                paddingLeft: "20px",
                paddingRight: "20px",
                "& hr": { mx: 0.5 },
              }}
            >
              {IsMuliClient == false || ClientTemplate == false ? (<>
                <Button
                  size="large"
                  variant="contained"
                  sx={{
                    textTransform: "capitalize",
                    padding: "12px",
                    marginBottom: "20px",
                    marginTop: "10px",
                    marginLeft: "auto"
                  }}
                  onClick={() => handleClickOpen("", 1)}
                  hidden={((getOrgType() == "Vendor" || getOrgType() == "Client") && [3, 7, 15, -1, 9, 26, 14, 5, 32, 33, 4, 31, 13, 16, 8]?.includes(PqStatusID)) ? false : ((getOrgType() == "Client") && [10]?.includes(PqStatusID) ? true : !VIEWMODE)}
                >
                  {" "}
                  + Add New
                </Button>
              </>) : (
                <>
                  <div hidden={getOrgType() != "Admin"}>
                    <Button
                      size="large"
                      variant="contained"
                      sx={{
                        textTransform: "capitalize",
                        padding: "12px",
                        marginBottom: "20px",
                        marginTop: "10px",
                      }}
                      onClick={ALockUnlock}
                    >
                      {Lock == true ? "UnLock Client Uploads" : "Lock Client Uploads"}
                    </Button>
                  </div>
                  <br></br>
                  <div className="mx-4" hidden={Lock}>
                    <Button
                      size="large"
                      variant="contained"
                      sx={{
                        textTransform: "capitalize",
                        padding: "12px",
                        marginBottom: "20px",
                        marginTop: "10px",
                      }}
                      onClick={() => handleClickOpen("", 4)}
                      // hidden={getOrgType() == "Vendor" ? false : !VIEWMODE}
                      hidden={(getOrgType() == "Vendor" && [3, 7, 15, -1, 9, 26, 14, 5, 32, 33, 4, 31, 13, 16, 8]?.includes(PqStatusID)) ? false : (getOrgType() == "Client" ? true : !VIEWMODE)}

                    >
                      {" "}
                      Add Client Documents
                    </Button>
                  </div>
                  <br></br>
                  <Button
                    size="large"
                    variant="contained"
                    sx={{
                      textTransform: "capitalize",
                      padding: "12px",
                      marginBottom: "20px",
                      marginTop: "10px",
                      marginLeft: "auto",
                    }}
                    onClick={() => handleClickOpen("", 5)}
                    //hidden={getOrgType() == "Vendor" ? false : !VIEWMODE}
                    hidden={((getOrgType() == "Vendor" || getOrgType() == "Client") && [3, 7, 15, -1, 9, 26, 14, 5, 32, 33, 4, 31, 13, 16, 8]?.includes(PqStatusID)) ? false : ((getOrgType() == "Client") && [10]?.includes(PqStatusID) ? true : !VIEWMODE)}

                  >
                    {" "}
                    Add Global Documents
                  </Button>
                </>
              )}
              <Dialog fullScreen={fullScreen} open={open}>
                <DialogContent sx={{ padding: "40px 48px" }}>
                  <DialogTitle
                    sx={{
                      textAlign: "center",
                      fontWeight: 500,
                      fontSize: 20,
                    }}
                  >

                    {id == 1 || id == 4 || id == 5 ? (
                      <>
                        <span style={{ fontSize: "larger" }}>
                          Upload Document for<br></br> Prequalification
                        </span>
                        <br></br>
                        <span style={{ color: "#667085", fontSize: "smaller" }}>
                          Please do not upload password- <br></br>protected
                          documents. It will delay your <br></br>
                          prequalification processing time
                        </span>
                      </>
                    ) : (
                      <>
                        {id == 3 ? (
                          <>
                            <span style={{ fontSize: "larger" }}>
                              Replace Document for <br></br> Prequalification
                            </span>
                            <br></br>
                            <span
                              style={{ color: "#667085", fontSize: "smaller" }}
                            >
                              Please do not upload password- <br></br>protected
                              documents. It will delay your <br></br>
                              prequalification processing time
                            </span>
                          </>
                        ) : (
                          <>
                            <span style={{ fontSize: "larger" }}>
                              Edit Document Details for <br></br>{" "}
                              Prequalification
                            </span>
                            <br></br>
                            <span
                              style={{ color: "#667085", fontSize: "smaller" }}
                            >
                              Please do not upload password- <br></br>protected
                              documents. It will delay your <br></br>
                              prequalification processing time
                            </span>
                          </>
                        )}
                      </>
                    )}
                  </DialogTitle>

                  {/* <div hidden={id == 2}>
                                        <input type="file" onChange={saveFile} />
                                    </div> */}

                  <div
                    className="drop"
                    {...getRootProps({ mmmt })}
                    hidden={id == 2}
                    style={{ padding: "10px" }}
                  >
                    <input {...getInputProps()} />

                    <span className="text-muted mt-2 fs">
                      <b>
                        <span className="mx-1 cl">
                          {t("DragandDrop.firstLabel1")}{" "}
                          <span className=" text-muted Fs">
                            or drag and drop
                          </span>{" "}
                        </span>
                      </b>
                    </span>
                    <br />

                    <span className=" text-muted Fs"> {thumbs}</span>
                  </div>

                  <div>
                    <FormControl hidden={ClientTemplate != true} sx={{ m: 1, width: 425 }}>
                      <span style={{ color: "#3E4A62" }}>Client Name</span>
                      <Select
                        sx={{
                          '& legend': { display: 'none' },
                          '& fieldset': { top: 0 },
                        }}
                        labelId="demo-multiple-name-label"
                        id="demo-multiple-name"
                        size="small"
                        value={docclientId || ""}
                        onChange={(e) => DoccClienthange(e.target.value)}
                        input={<OutlinedInput label="Client Name" />}
                        MenuProps={MenuProps}
                      >
                        {clientList?.map((item) => (
                          <MenuItem key={item.key} value={item.key}>
                            {item.value}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div>
                    <FormControl sx={{ m: 1, width: 425 }}>
                      <span style={{ color: "#3E4A62" }}>Document Category<small style={{ color: "red" }}>*</small></span>
                      <Select
                        sx={{
                          '& legend': { display: 'none' },
                          '& fieldset': { top: 0 },
                        }}
                        labelId="demo-multiple-name-label"
                        id="demo-multiple-name"
                        size="small"
                        value={DocTypeID || ""}
                        onChange={(e) => handleChanged(e.target.value)}
                        input={<OutlinedInput label="Document Category" />}
                        MenuProps={MenuProps}
                      >
                        {SupportDocTypes?.map((item, index) => (
                          <MenuItem title={item.docTypeName} key={index} value={item.docTypeID}>
                            {item.docTypeName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div>

                    <FormControl sx={{ m: 1, width: 425, display: DocTypes == true ? "block" : "none" }}>
                      <span style={{ color: "#3E4A62", marginTop: 1 }}>Expiration Date for the Document <small style={{ color: "red" }}>*</small></span>
                      {/* <TextField type='date'
                        value={newDate || ""}
                        onChange={(e) => {
                          ChangeDate(e.target.value);
                        }}
                        onKeyDown={(e) => e.preventDefault()}
                        size='small'
                        sx={{
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                          width: "425px"
                        }} /> */}
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          views={["year", "month", "day"]}
                          value={newDate}
                          name="toDate"
                          onChange={(e) => {
                            ChangeDate(e);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              sx={{
                                "& legend": { display: "none" },
                                "& fieldset": { top: 0 },
                                width: "425px",
                              }}
                              name="toDate"
                              size="small"
                              onKeyDown={handleDateKeyDown}
                            />
                          )}
                        />
                      </LocalizationProvider>

                    </FormControl>

                  </div>

                  <DialogActions >
                    <div className="login-help__buttonContainer mt-4">
                      <Button variant="contained" className="login-help-button-cancel mx-2" onClick={handleClose}>Cancel</Button>
                      {newDate == '' ? (
                        <Tooltip title="Please fill all the mandatory fields" followCursor>
                          <span>
                            <Button variant="contained" className="login-button-request mx-2" disabled={newDate == ''} >{id == 3 || id == 2 ? "Save " : "Add"}</Button>
                          </span>
                        </Tooltip>
                      ) : (
                        <>
                          <Button variant="contained" disabled={Dis} className="login-button-request mx-2" onClick={uploadFile}>{id == 3 || id == 2 ? "Save " : "Add"}</Button>

                          <Backdrop
                            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                            open={Dis}
                          >
                            <CircularProgress color="inherit" />
                          </Backdrop>
                        </>
                      )}
                      {open && showPrompt && (
                        <Dialog
                          open={showPrompt}
                          onClose={() => setShowPrompt(false)}
                        >
                          <DialogTitle>
                            No Documents has been linked for this questionnaire,
                            please contact FIRST, VERIFY at (402) 562-5930 or
                            info@firstverify.com
                          </DialogTitle>
                          <DialogActions className="w-100 d-flex">
                            <Button
                              onClick={() => setShowPrompt(false)}
                              sx={{ minHeight: "39px", minWidth: "90px" }}
                              className="shadow-none "
                              variant="contained"
                              color="primary"
                              autoFocus
                            >
                              OK
                            </Button>
                          </DialogActions>
                        </Dialog>
                      )}
                    </div>
                  </DialogActions>
                </DialogContent>
              </Dialog>
            </Box>
            {response?.map((p, i) => (
              <div key={i}>
                <Accordion
                  className={"sub-accordion-root rounded"}
                  expanded={accordiansExpanded.includes(i) || !ClientTemplate}
                  onChange={handleAccordion(i)}

                // sx={{ backgroundColor: "#7a7a7a80" }}
                >
                  <AccordionSummary
                    expandIcon={ClientTemplate ? <ExpandMoreIcon /> : <EmptyComponent />}
                    aria-controls="panel4bh-content"
                    sx={{ backgroundColor: "#7a7a7a80" }}
                  >
                    <span>
                      {p[0] != null &&
                        (p[1][0].organizationType == "Super Client" ? (
                          <span
                            style={{ color: "#4d4d4e", marginRight: "auto", fontSize: "22px", fontWeight: "bold" }}
                          >
                            Global Documents
                          </span>
                        ) : (
                          <span
                            style={{ color: "#4d4d4e", marginRight: "auto", fontSize: "22px", fontWeight: "bold" }}
                          >
                            {p[1][0].clientName}
                          </span>
                        ))}
                    </span>
                  </AccordionSummary>
                  <AccordionDetails>

                    {getGroupData(
                      p[1]?.filter((x) => x.documentStatus !== "Deleted")
                    )
                      .map((t) => ({
                        ...t,
                        items: t[1]?.sort((a, b) => {
                          // Sort by latest updatedOn date first
                          const updatedOnDateDiff = new Date(b.updatedOn) - new Date(a.updatedOn);
                          if (updatedOnDateDiff !== 0) return updatedOnDateDiff;
                        
                          // Sort by documentStatus null first
                          if (a.documentStatus === null && b.documentStatus !== null) return -1;
                          if (a.documentStatus !== null && b.documentStatus === null) return 1;
                        
                          // Then sort alphabetically by documentStatus
                          if (a.documentStatus !== null && b.documentStatus !== null) {
                            if (a.documentStatus.toLowerCase() > b.documentStatus.toLowerCase()) return -1;
                            if (a.documentStatus.toLowerCase() < b.documentStatus.toLowerCase()) return 1;
                          }
                        
                          // Sort by uploaded date in descending order
                          const uploadedDateDiff = new Date(b.uploaded) - new Date(a.uploaded);
                          return uploadedDateDiff;
                        }),
                      })).map((t, i) => (
                        <div>
                          <Card
                            sx={{
                              margin: "auto",
                              backgroundColor: "#DBEAF4",
                              padding: 2,
                              marginTop: 2,
                            }}
                          >
                            <span style={{ color: "#2A93DB", marginRight: "auto", fontSize: "22px", fontWeight: "bold" }}>
                              {t[1][0].documentTypeName}
                            </span>
                          </Card>
                          {t[1]?.map((r, i) => (
                            <div key={i} id={r?.documentId}>
                              {r.documentStatus != "Deleted" ? (
                                <>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      paddingLeft: "20px",
                                      paddingRight: "20px",
                                      "& hr": { mx: 0.5 },
                                    }}
                                  >
                                    <span
                                      style={{
                                        marginRight: "auto",
                                        textDecoration: "none",
                                        marginTop: "10px",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      <Stack direction={"row"} spacing={1}>
                                        <span>
                                          {r.toggle ? (
                                            <TextField
                                              size="small"
                                              sx={{
                                                "& legend": { display: "none" },
                                                "& fieldset": { top: 0 },
                                              }}
                                              required
                                              type="text"
                                              className=""
                                              variant="outlined"
                                              value={values} // Use value instead of defaultValue
                                              onChange={(e) => ChangeDocName(e.target.value)}
                                            />
                                          ) : (
                                            <Tooltip title={r.documentName} placement="top" arrow>
                                              <div
                                                style={{
                                                  flex: 1,
                                                  overflow: "hidden",
                                                  textOverflow: "ellipsis",
                                                  whiteSpace: "nowrap",
                                                  maxWidth: "500px",
                                                }}
                                              >
                                                <a
                                                  onClick={() => handleDownload(r)}
                                                  style={{
                                                    marginRight: "auto",
                                                    textDecoration: "none",
                                                    marginTop: "10px",
                                                    marginBottom: "10px",
                                                    color: " #2A93DB",
                                                    cursor: "pointer",
                                                    fontSize: "22px",
                                                  }}
                                                >
                                                  {r.documentName}
                                                </a>
                                              </div>
                                            </Tooltip>
                                          )}
                                        </span>
                                        <div>
                                          {getOrgType() != "Admin" ? (
                                            ""
                                          ) : (
                                            <>
                                              {r.toggle ? (
                                                <SaveIcon
                                                  sx={{ fontSize: "25px", cursor: "pointer" }}
                                                  onClick={() => EditFile(r)}
                                                />
                                              ) : (
                                                <EditIcon
                                                  sx={{ fontSize: "25px", cursor: "pointer" }}
                                                  onClick={() => handleClick(r)}
                                                />
                                              )}
                                            </>
                                          )}
                                        </div>
                                      </Stack>
                                    </span>
                                    <span
                                      style={{
                                        display:
                                          r?.expires == null ? "none" : "block",
                                      }}
                                    >
                                      {new Date(r?.expires).getTime() >
                                        PresentDate.getTime() ? (
                                        <span style={{ fontWeight: "bold" }}>
                                          Expires on : &nbsp;
                                          {GetfVDateFormate("", r?.expires)}
                                        </span>
                                      ) : (
                                        <span style={{ color: "red", fontWeight: "bold" }}>

                                          Expired on :&nbsp;
                                          {GetfVDateFormate("", r?.expires)}
                                        </span>
                                      )}
                                    </span>

                                    {/* {getOrgType() != "Admin" ? "" : <> */}
                                    <IconButton
                                      aria-label="Restore"
                                      onClick={() => DocHistoryhandle(r)}
                                      hidden={getOrgType() != "Admin"}
                                    >
                                      <img
                                        src={Restore}
                                        alt="Restoreicon"
                                        style={{ width: "25px" }}
                                      />
                                    </IconButton>

                                    <IconButton
                                      aria-label="Replace"
                                      onClick={() => handleClickOpen(r, 3)}
                                      hidden={getOrgType() != "Admin"}
                                    >
                                      <img
                                        src={Replace}
                                        alt="Replaceicon"
                                        style={{ width: "50px" }}
                                      />
                                    </IconButton>

                                    <IconButton
                                      aria-label="edit"
                                      onClick={() => handleClickOpen(r, 2)}
                                      hidden={getOrgType() == "Client" || (getOrgType() == "Vendor" && ![3, 7, 15]?.includes(PqStatusID))}
                                    >
                                      <img
                                        src={Edit}
                                        alt="Editicon"
                                        style={{ width: "25px" }}
                                      />
                                    </IconButton>

                                    <IconButton
                                      aria-label="delete"
                                      onClick={() => HandleDownloadopen(r)}
                                      hidden={getOrgType() != "Admin"}
                                    >
                                      <img
                                        src={Trash}
                                        alt="Deleteicon"
                                        style={{ width: "25px" }}
                                      />
                                    </IconButton>
                                    {/* // </>} */}
                                  </Box>
                                  <div >
                                    <div style={{ textAlign: "center" }}>
                                      <p>
                                        {" "}
                                        Uploaded on{" "}
                                        {r?.uploaded != null
                                          ? GetfVDateFormate("", r?.uploaded)
                                          : r?.uploaded}{" "}
                                        by {r?.uploaderFullName}
                                      </p>


                                      <p className="mx-3" hidden={!r?.updatedOn}>
                                        Last Updated on{" "}
                                        {r?.updatedOn != null
                                          ? GetfVDateFormate("", r?.updatedOn)
                                          : r?.updatedOn}{" "}
                                        by {r.updatedByUserFullName}
                                      </p>
                                    </div>
                                    {getOrgType() != "Admin" ? "" :
                                      <p className="mx-3" hidden={!r?.documentStatus}>
                                        {r?.documentStatus == "Rejected" ? <img src={CancelCircleBlue} alt="CancelCircle" /> : <img src={CheckCircleBlue} alt="CheckCircle" />}  Status: {r?.documentStatus} on{" "}
                                        {r?.statusChangeDate != null
                                          ? GetfVDateFormate("", r?.statusChangeDate)
                                          : r?.statusChangeDate}{" "}
                                        by {r?.statusChangedUserFullName}
                                      </p>
                                    }
                                    {getOrgType() != "Admin" ? "" :
                                      <Button
                                        size="large"
                                        //color={(r?.documentStatus == "Reject" || r?.documentStatus == null) ? "success" : "error"}
                                        //color="Secondary"
                                        variant="contained"
                                        sx={{
                                          textTransform: "capitalize",
                                          padding: "12px",
                                          marginBottom: "20px",
                                          marginLeft: "20px",
                                          marginTop: "10px",
                                          //Color: "#fff",
                                          '&:hover': {
                                            backgroundColor: (r?.documentStatus == "Rejected" || r?.documentStatus == null) ? "#1b9447" : "#cc0000",
                                            borderColor: (r?.documentStatus == "Rejected" || r?.documentStatus == null) ? "#1b9447" : "#cc0000",
                                            boxShadow: 'none',
                                          },
                                          backgroundColor: (r?.documentStatus == "Rejected" || r?.documentStatus == null) ? "#1b9447" : "#cc0000"
                                        }}
                                        onClick={() => RejectORAprove(r)}
                                      >
                                        {r?.documentStatus == "Rejected" ||
                                          r?.documentStatus == null
                                          ? "Approve"
                                          : "Reject"}
                                      </Button>
                                    }
                                    <hr />
                                  </div>
                                </>
                              ) : (
                                ""
                              )}
                            </div>
                          ))}
                        </div>
                      ))}
                  </AccordionDetails>
                </Accordion>
              </div>
            ))}

            <Dialog fullScreen={fullScreen} open={DeletePop}>
              <DialogContent sx={{ padding: "40px 48px" }}>
                <DialogTitle
                  sx={{
                    textAlign: "center",
                    fontWeight: 500,
                    fontSize: 20,
                  }}
                >
                  Delete Document
                </DialogTitle>
                Are you sure, you want to delete this document?<br></br>
                This action cannot be undone.
                <DialogActions>
                  <div className="login-help__buttonContainer mt-4">
                    <Button
                      variant="contained"
                      className="login-help-button-cancel mx-2"
                      onClick={HandleDownloadClose}
                    >
                      Cancel
                    </Button>
                    <Button
                      disabled={DeleteDis == true}
                      variant="contained"
                      className="login-button-request mx-2"
                      onClick={RemovieFile}
                    >
                      Delete
                    </Button>
                  </div>
                </DialogActions>
              </DialogContent>
            </Dialog>

            <Dialog
              sx={{
                "& .MuiDialog-container": {
                  "& .MuiPaper-root": {
                    width: "100%",
                    maxWidth: "1050px", // Set your width here
                  },
                },
              }}
              // fullScreen={fullScreen}
              open={historyOpen}
              onClose={HistoryClose}
              aria-labelledby="responsive-dialog-title"
            >
              <SupportingDocumentEdit
                history={history}
                HistoryClose={HistoryClose}
                DocName={DocName}
              />
            </Dialog>
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion
        onChange={DeletedDocuments}
        sx={{ backgroundColor: "#F9FAFB", marginTop: "20px" }}
        hidden={getOrgType() != "Admin"}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography sx={{ width: "33%", flexShrink: 0 }}>
            Deleted Documents
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            {response?.map((p, i) => (
              <div key={i}>
                {/* <div>{r[0]}</div> */}
                <Accordion
                  className={"sub-accordion-root rounded"}
                  expanded={accordiansExpanded1.includes(i) || !ClientTemplate}
                  onChange={handleAccordion1(i)}

                // sx={{ backgroundColor: "#7a7a7a80" }}
                >
                  <AccordionSummary
                    expandIcon={ClientTemplate ? <ExpandMoreIcon /> : <EmptyComponent />}
                    aria-controls="panel4bh-content"
                    sx={{ backgroundColor: "#7a7a7a80" }}
                  >
                    <span>
                      {p[0] != null &&
                        (p[1][0].organizationType == "Super Client" ? (
                          <span
                            style={{ color: "#4d4d4e", marginRight: "auto", fontSize: "22px", fontWeight: "bold" }}
                          >
                            Global Documents
                          </span>
                        ) : (
                          <span
                            style={{ color: "#4d4d4e", marginRight: "auto", fontSize: "22px", fontWeight: "bold" }}
                          >
                            {p[1][0].clientName}
                          </span>
                        ))}
                    </span>
                  </AccordionSummary>
                  <AccordionDetails>
                    {getGroupData(p[1])?.map((t, i) => (
                      <div key={i}>
                        <Card
                          sx={{
                            margin: "auto",
                            backgroundColor: "#DBEAF4",
                            padding: 2,
                            marginTop: 2,
                            display:
                              t[1][0].documentStatus == "Deleted"
                                ? "block"
                                : "none",
                          }}
                        >
                          <span style={{ color: "#2A93DB", marginRight: "auto", fontSize: "22px", fontWeight: "bold" }}>
                            {t[1][0].documentTypeName}
                          </span>
                        </Card>
                        {t[1]?.map((r, i) => (
                          <div key={i} id={r?.documentId}>
                            {r?.documentStatus == "Deleted" ? (
                              <>
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    paddingLeft: "20px",
                                    paddingRight: "20px",
                                    "& hr": { mx: 0.5 },
                                  }}
                                >
                                  <span
                                    style={{
                                      marginRight: "auto",
                                      textDecoration: "none",
                                      marginTop: "10px",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    <span
                                      style={{
                                        marginRight: "auto",
                                        textDecoration: "none",
                                        marginTop: "10px",
                                        marginBottom: "10px",
                                        color: " #2A93DB",
                                        cursor: "pointer",
                                        fontSize: "22px",
                                      }}
                                      onClick={() => handleDownload(r)}
                                    >
                                      {r.documentName}
                                    </span>
                                  </span>
                                  <IconButton
                                    aria-label="edit"
                                    onClick={() => DocHistoryhandle(r)}
                                  >
                                    <img
                                      src={Restore}
                                      alt="Restoreicon"
                                      style={{ width: "25px" }}
                                    />
                                  </IconButton>
                                </Box>
                              </>
                            ) : (
                              ""
                            )}
                          </div>
                        ))}
                      </div>
                    ))}
                  </AccordionDetails>
                </Accordion>
              </div>
            ))}


          </Typography>
        </AccordionDetails>
      </Accordion>

      <div className="mt-" hidden={PqNonStatusList?.includes(PqStatusID)}>
        <small style={{ color: "red" }}>
          If you updated an expired document, you do not need to click the
          Complete & Continue button again – just log out. However, if you
          have not yet submitted the questionnaire for review, you must
          click the Complete & Continue button and complete the Finalize &
          Submit section.
        </small>
      </div>
    </div >
  );
}
